window.addEventListener('load', function() {
  document.addEventListener('click', function(e) {
    const button = e.target.closest('button.btn-calc-shipping');

    if (button) {
      e.preventDefault();

      var form = button.closest('form');
      var address_province = '';
      var address_zip = parseInt(form.querySelectorAll('.address_zip')[0].value, 10);
      if ((address_zip >= 1000 && address_zip <= 2599) || (address_zip >= 2620 && address_zip <= 2899 || (address_zip >= 2921 && address_zip <= 2999))) {
        address_province = 'New South Wales';
      } else if ((address_zip >= 3000 && address_zip <= 3999) || (address_zip >= 8000 && address_zip <= 8999)) {
        address_province = 'Victoria';
      } else if ((address_zip >= 4000 && address_zip <= 4999) || (address_zip >= 9000 && address_zip <= 9999)) {
        address_province = 'Queensland';
      } else if (address_zip >= 5000 && address_zip <= 5999) {
        address_province = 'South Australia';
      } else if (address_zip >= 6000 && address_zip <= 6999) {
        address_province = 'Western Australia';
      } else if (address_zip >= 7000 && address_zip <= 7999) {
        address_province = 'Tasmania';
      } else if ((address_zip >= 200 && address_zip <= 299) || (address_zip >= 2600 && address_zip <= 2619) || (address_zip >= 2900 && address_zip <= 2920)) {
        address_province = 'Australian Capital Territory';
      } else if (address_zip >= 800 && address_zip <= 999) {
        address_province = 'Northern Territory';
      }

      var execute = async function() {
        var params = new URLSearchParams({
          'shipping_address[country]': 'Australia',
          'shipping_address[province]': address_province,
          'shipping_address[zip]': address_zip + ''
        });
  
        button.setAttribute('disabled', 'disabled');
        button.textContent = "Calculating...";
  
        var response = await fetch('/cart/shipping_rates.json?' + params, {
          method: "GET"
        });

        if (response.ok) {
          var rates = await response.json();
          if (rates !== null) {
            rates = rates.shipping_rates;
            if (rates.length) {
              form.getElementsByClassName('shipping-value')[0].innerHTML = '$' + rates[0].price;
              calculateCartTotalPrice(); /* from cart-drawer.liquid */
            }
          }
        }
  
        button.removeAttribute('disabled');
        button.textContent = "Calculate";
      };
  
      execute();
    }
  });
});